export const CREATE_GAME_ACTION = 'createGame'
export const JOIN_GAME_ACTION = 'joinGame'
export const GAME_PROGRESS_ACTION = 'gameProgress'
export const START_GAME_ACTION = 'startGame'
export const NEXT_GAME_ACTION = 'nextGame'
export const LEAVE_GAME_ACTION = 'leaveGame'

export const ERROR_RESPONSE = 'errorResponse'
export const CREATE_GAME_RESPONSE	= 'createGameResponse'
export const JOIN_GAME_RESPONSE = 'joinGameResponse'
export const NEW_PLAYER_RESPONSE = 'newPlayerResponse'
export const GAME_PROGRESS_RESPONSE = 'gameProgressResponse'
export const PLAYER_FINISHED_RESPONSE = 'playerFinishedResponse'
export const GAME_FINISHED_RESPONSE = 'gameFinishedResponse'
export const GAME_START_RESPONSE = 'gameStartResponse'
export const NEXT_GAME_RESPONSE = 'nextGameResponse'
export const LOBBY_CLOSED_RESPONSE = 'lobbyClosedResponse'
export const LEAVE_GAME_RESPONSE = 'leaveGameResponse'
